var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.009 0 5 .002V2H2v8h8V7h2v2.991A2.01 2.01 0 0 1 9.991 12H2.01A2.01 2.01 0 0 1 0 9.991V2.01A2.01 2.01 0 0 1 2.009 0M10.5 0 12 1.5 6.5 7H5V5.5z"
})));
export default SvgCreate;